import {GetHealthDatesModel} from "domain/usecases";
import {makeGetHealthDates} from "main/factories/usecases";
import {GetTelehealthMostRecentDateParams} from "./types";
import {staticParams} from "./constants";

async function getTelehealthMostRecentDate(params: GetTelehealthMostRecentDateParams): Promise<
  GetHealthDatesModel['content'][number]
> {
  const {
    content: [mostRecentDate],
  } = await makeGetHealthDates().get({...params, ...staticParams});
  return mostRecentDate;
}

export {
  getTelehealthMostRecentDate,
}
